import Vue from 'vue'
// i18n国际化
import ElementUI from 'element-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from '@/assets/lang/index'
import axios from '@/assets/js/axiosExtend.js'
import VueAxios from 'vue-axios'
import qs from 'qs'
import '@/assets/js/dialogDrag'
// import '@/assets/js/jquery.flot.js'
// import '@/assets/js/jquery-ui.min.js'
// import '@/assets/js/socket.io.js'
// import '@/assets/js/adpter.js'
// import '@/assets/js/client.js'
import '@/assets/js/iconfont.js'
// import '@/assets/js/wp.js'
// import creatWebsocket from '@/assets/js/common/creatWebsocket'
import BehaviorSyns from '@/assets/js/common/BehaviorSyns'
// import IpStreamOut from 'ip-stream-out'
import '@/assets/bootstrap/dist/css/bootstrap.min.css'
import '@/assets/bootstrap/dist/js/bootstrap.min.js'
import '@/assets/css/common.less'
import '@/assets/iconfont/iconfont.css'
import '@/assets/iconfont/iconfont.js'

import '@/assets/css/toast.css'

// 日历插件
import FullCalendar from 'vue-full-calendar'

// 注册全局指令
// 滚动加载
import Scroll from '@/directive/scroll'
// 过滤特殊字符
// import FilterSpecialChar from '@/directive/filterSpecialChar'
// 节流
import repeatClick from '@/directive/repeatClick'

import '@/directive/inputValScope'

// 气泡提示
import Toast from '@/assets/js/toast'

// 主题色
import '../theme/index.css'

// global css
import '@/assets/css/index.less'

import deviceInfo from '@/assets/js/common/handleDeviceInfo'

import filters from '@/assets/js/filters'

/** test */
// import * as Sentry from '@sentry/vue'
// import { Integrations } from '@sentry/tracing'
/** test */

Vue.prototype.$BehaviorSyns = BehaviorSyns

Vue.use(FullCalendar)
Vue.use(Scroll)
// Vue.use(FilterSpecialChar)
Vue.use(repeatClick)
Vue.use(Toast)

window.Vue = Vue
Object.keys(deviceInfo).forEach((key) => Vue.filter(key, deviceInfo[key]))
// 遍历注册全局过滤器
Object.keys(filters).forEach((key) => Vue.filter(key, filters[key]))
Vue.use(ElementUI, {
  i18n: (key, val) => i18n.t(key, val) // 用于elementUI插件的中英文翻译
})
// 供集成的外部js使用
window.JSMessage = ElementUI.Message
window.JSConfirm = ElementUI.MessageBox

Vue.use(qs)
Vue.use(VueAxios, axios)
// Vue.use(creatWebsocket)
// Vue.use(IpStreamOut)
Vue.config.productionTip = false

// 全局变量挂载到原型中
// Vue.prototype.FLOT = Flot;
// 集成sentry 环境设置
// let environmentTag = 'development'; const hostName = window.location.hostname
// if (hostName.includes('playout.tvunetworks.com')) {
//   environmentTag = 'production-test'
// }
// /** test */
// environmentTag != 'development' && Sentry.init({
//   environment: environmentTag,
//   Vue,
//   dsn: 'https://15d0cdbd42dd43d09fcaff2a8e75d8e6@o982456.ingest.sentry.io/5938309',
//   release: localStorage.getItem('newChannelVersion'),
//   integrations: [
//     new Integrations.BrowserTracing({
//       routingInstrumentation: Sentry.vueRouterInstrumentation(router),
//       tracingOrigins: ['cc-ms-dev.tvunetworks.com', 'playout.tvunetworks.com', /^\//]
//     })
//   ],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 0.2

// })
// /** test */

window.vm = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
  watch: {
    $route: () => {
      window.Appcues.page()
    }
  }
}).$mount('#app')
